module.exports = __webpack_public_path__ + "static/media/49_Print.4d15e6a6.png";